<template>
  <div class="content if-profile">  
    <div class="md-layout if-profile-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header m-0">
        <div class="md-layout">

          <div class="md-layout-item md-medium-size-70 md-xsmall-size-100 md-size-70 p-0">
            <h4>Prospect Lists</h4>
          </div>

          <div class="md-layout-item md-xsmall-size-30 md-size-30 button-box">
            <!-- <div class="md-layout fi-profile-pdf-box">
              <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-15">
                <md-button
                    class="md-info md-block access-button"
                    v-on:click="downloadCSVData"
                >CSV
                  <md-icon class="ml-5">table_rows</md-icon>
                </md-button>
              </div>
            </div> -->
            <md-button class="md-info csv_btn access-button" v-on:click="downloadCSVData">
              <md-icon class="ml-5">receipt_long</md-icon>Download CSV
            </md-button>
          </div>
          <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 if_card">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
              <collapse
                  :collapse="['Company List']"
                  icon="keyboard_arrow_down"
                  color-collapse="info"
                  :active="true">
                <template slot="md-collapse-pane-1">
                  <div class="md-layout">
                    <div class="financal-report-col-1">
                      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 financal-report-col-1">
                        <div class="md-layout-item md-medium-size-30 md-xsmall-size-100 md-size-30">
                          <img src="/img/image_placeholder.jpg"/>
                        </div>
                        <div class="md-layout-item md-medium-size-70 md-xsmall-size-100 md-size-70 p-0">
                          <h6><i class="md-icon">event_available</i>Date:</h6>
                          <p>December 2020</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </collapse>
            </div>
          </div>-->
        </div>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 abut-tb-cntnt">
        <nav-tabs-card class="profile-layout-tbs if_card">
          <template slot="content">
            <md-tabs md-alignment="left" class="p-0">
              <md-tab id="cash-flow" md-label="About Bizminer" md-icon="join_inner" class="p-0 ss">
                <div class="md-toolbar-row fundamentals_area p-0">
                  <div class="extra_space">
                    <h1 class="md-title text-left profile-title">
                      About Bizminer
                    </h1>
                    <p>
                      Bizminer has over 20 years of providing the most granular industry statistical profiles in the market. We offer industry financial analysis benchmarks for over 5,000 lines of business and industry market trends on thousands more. Our profiles are available at the national and local levels down to the zip code. The ability to structure by industry, geographic location, sales class and tax structure is unparalleled and truly provides for an infinite number of report combinations. We specialize in granularity and depth. We stride to provide hard sought local data that professionals who service small businesses rely upon to make strategic decisions. </p>
                      <p>We contribute to the delicate balance of fair, ethical commerce in the US and, increasingly, around the world. We are always aware and proud of the role we play where we provide tens of thousands of financial and industry market trends each year to business valuation professionals whose judgments are used to establish fair prices for business sales, litigation and merger transactions.</p>
                      <p>We provide accountants with thousands of industry financial analysis to help their clients establish business goals and benchmarks. We provide benchmarking content to over 15,000 bank agents who use it to assess risk, develop business loans and market their services.</p>
                      <p>Business owners access our reports to help create business plans, for use in loan applications or to find new business markets and opportunities. </p>
                      <p>We help lenders make decisions on new loans to originate to their small business customers and a growing number of lenders who are complimenting their small business owner residential mortgage business to get deals across the line that they might not otherwise be able to. </p>
                      <p>There’s a growing number of investors moving down stream and leveraging Bizminer to produce insights on transactions they are working on and potential investments they are seeking to make. We are seeing activity from Family Offices across to Private Equity Funds. </p>
                      <p>And finally, we help over 300,000 business students and counting train for the future, equipping them with the tools to make the most of entrepreneurship, accounting, finance, economics, and marketing programs as they grow into tomorrow's business leadership.</p>
<br /><br />
                   

                  </div>

                </div>
              </md-tab>
              <md-tab id="about-methodology" md-label="Methodology" md-icon="table_chart" class="p-0 ss">
                <div class="md-toolbar-row fundamentals_area p-0">
                  <div class="extra_space">
                    <h1 class="md-title text-left profile-title"> Methodology </h1>
                    <h2 class="title-h3-formatting">Taxonomy</h2>
                    <p>Because of our data driven approach to providing robust, accurate and fresh
                      benchmarking data, our proprietary industry classification system utilizes an
                      expanded version of the North American Industrial Classification System (NAICS).
                      Reports through the December 2012 release utilize the NAICS 2007 version. Beginning
                      with our Spring 2013 release, reports will utilize the NAICS 2012 version, which incorporates
                      minor changes. </p>
                    <p>
                      In addition to the standard NAICS coding, which classifies about 1200 industry segments through
                      the use of 2-3-4-6 digit industries in 19 sectors, BizMiner applies further in-house segmentation
                      of many NAICS-6 industries by incorporating a decimal point and up to eight digits after the
                      decimal. This allows us to classify and report on specialty industry segments (for example, [Pizza
                      Restaurants (Limited Service & Take-Out) NAICS 722211.0623] rather than only the broader [Limited
                      Service & Take-Out Restaurants NAICS-722211]. When using our drill-down search, or our code input
                      search, industry segments will be displayed in numerical order, with specialty segments indented
                      under the NAICS-6 parent industry.
                    </p>
                    <h3>Data Point Timing</h3>
                    <p>Financial data represents end-of year averages for the industry and each sales class report.
                      Summer release reports display calendar year-end content in each data column marked by a year;
                      Winter release reports display calendar year-end content plus an “extra” final column that
                      displays content for the running 12 years through the second quarter of the following year. The
                      December 2012 release, for example, displayed calendar year content for 2007-2011 and a final
                      2012q2 column that displayed content for the running twelve months 2011q2-2012q2.</p>
                    <h3>Sales Trends </h3>
                    <p>Our US Industry Financial series analyzes corporate reports, Our Micro-firm series analyzes sole
                      proprietorships. Dollar-based sales and other dollar-based data in these reports reflect averages
                      for sales of the industry segment, not total industry-wide averages. In order to maximize the data
                      available for smaller areas, our Local Industry Financial series aggregates available data from
                      corporate, sole proprietorship and other firms and bases its format on corporate (IRS 1120)
                      reporting. Dollar values in all reports may not sum due to rounding</p>
                    <p>In US and Local Financial reports, the rollup process is identical (see below). Average Annual
                      Business Receipts in Local Financial Reports may differ from average annual sales in our Industry
                      Market Report series due to one of two reasons: a) some firms may not be included in the financial
                      series, and b) specific sales classes may not be represented in sufficient numbers or integrity to
                      be displayed or included in roll-ups. Additionally, specific industry sales classes segments must
                      display data in sufficient numbers and integrity for five years in order to be included in
                      industry-wide or parent rollups, and in specific offspring classifications for five years in order
                      to be included in parent NAICS roll-ups. </p>
                    <h3>Local Financial Data </h3>
                    <p>Local Financial Data is projected from US data through the development of algorithms using
                      available localized state and metro data, including sales, wage and other proprietary input-output
                      metrics. In local Industry Financial reports, the "Other Income" line item percentage is applied
                      directly from US averages for this industry. Local In local Industry Financial reports, the "Other
                      Income" line item percentage is applied directly from US averages for this industry. Local
                      percentages may differ. Other P&L percentages and all dollar calculations are based on actual
                      local data. </p>
                    <h3>Year to Year Overlap </h3>
                    <p>Although year-to-year overlap is consistent, and may approach 100% in some cases, our financial
                      databases do not require 100% overlap of firms from year to year. It is important to understand
                      that this is an impossibility, and not be swayed by other sources that may claim a 100% overlap. A
                      100% overlap suggests that no firms enter the market, no firms cease operation, and no firms
                      transition between sales classes in any given year. This is some not the real-life situation,
                      because all of these dynamics occur every year in every industry. As well, due to the dynamic of
                      firms transitioning from one sales to another (up or down) in any given year, year-to-year dollar
                      sales in specific sales classes may be affected by firms which have transitioned in or out in
                      either direction </p>
                    <h3>Business Revenue</h3>
                    <p>includes receipts from core business operations. Interest Income and Other income (such as rents
                      and royalties) are generally detailed separately below Operating Income. While Business Revenue is
                      separated from Interest Income for most classifications, Business Revenue includes interest income
                      from the private sector where it is central to financial industry operations, including Credit
                      Intermediation and Related Activities (522xxx); Funds, Trusts, and Other Financial Vehicles
                      (525xxx); and Management of Companies and Enterprises (55xxxxx).Beginning in October, 2011, Other
                      income in Real Estate (531xxx) and Lessors of Nonfinancial Intangible Assets (53311xx)is
                      reclassified into Business Revenue, and in some cases, may recast 2010 Cost of Sales with other
                      compensation-related items.</p>
                    <h3>Cost of Sales </h3>
                    <p>includes materials and labor involved in the direct delivery of a product or service. Other costs
                      are included in the cost of sales to the extent that they are involved in bringing goods to their
                      location and condition ready to be sold. Non-production overheads such as development costs may be
                      attributable to the cost of goods sold. The costs of services provided will consist primarily of
                      personnel directly engaged in providing the service, including supervisory personnel and
                      attributable overhead. To allow for common reporting practices, Cost of Sales is fixed at zero for
                      NAICS industry groups within these ranges: 522-523-525-55 (except 5242).</p>
                    <h3>Compensation</h3>
                    <p>In addition to the labor portion of Cost of Sales, wage costs are reflected in the Officers
                      Compensation and Wages-Salary line items. In many cases, SG&A (Sales, General and Administrative)
                      costs also include some overhead, administrative and supervisory wages. </p>
                    <h3>Balance Sheet </h3>
                    <p>Liabilities, net worth and ratios are calculated for each industry segment and class, while asset
                      line items are blended with the closest four digit industry segment.</p>
                    <h3>Sources & Uses</h3>
                    <p>The Sources and Uses of Funds table tests the accuracy of the balance sheet and distinguishes the
                      sources of funds from their use. It is the basic worksheet preliminary to a formal cash flow
                      statement examining the liquidity of a business. A multi-year industry benchmark common size
                      balance sheet, which includes overlapped but not identical sets of firms in each year, is not
                      well-suited for the presentation of a formal cash flow analysis. </p>
                    <h3>“Roll Up” Protocol </h3>
                    <p>Industry-wide financial reports (both Industry Financial and Micro-Firm series) include rolled-up
                      data only from sales classes which are available in each of the prior five reporting years. Sales
                      classes included in the NAICS-6 roll-up of a particular release are now listed on P1 of each
                      NAICS-6 industry-wide report. As additional sales classes become consistently available, they will
                      be added to new NAICS-6 industry-wide and rolled-up NAICS-2-3-4-5 report releases. <br> In
                      addition, NAICS 2-3-4-5 reports are roll-ups from those NAICS-6 industries for which we have
                      complete (3-year or 5-year) data. Offspring industries applied to roll-are listed on P1 of
                      NAICS-2-3-4-5 roll-up reports.</p>
                    <h3>Negative Ratios</h3>
                    <p>To avoid confusion regarding division display of negative value line items, adjustments are made
                      to display "n/a" rather than negative ratios except in cases of negative net income. </p>
                    <h3>Treatment of Interest Income and Other Income</h3>
                    <p>Certain industry sectors consistently reflect ambiguity and overlap between core Business
                      Revenue, Interest Income and Other Income allocations. This issue is particularly prevalent in
                      industries, such as Finance-Insurance, Real Estate and Management of Companies which rely heavily
                      on all three. Differentiating these line items has in the past resulted in confusion around the
                      display of the P&L breakdown and the Asset:Sales relationship (since the Sales portion is based on
                      Business Revenue only). For this reason, all three income lines in the affected sectors (NAICS
                      52xxxx-53xxxx-55xxxx) are now collapsed into a single top-line Income item. Because of persistent
                      inconsistencies in Cost of Sales allocations in financial statements, Cost of Sales has been fixed
                      at zero for NAICS 522-523-525-55. The Insurance Agencies, Brokerages, and Other Insurance Related
                      Activities (NAICS 5242) industry group does not exhibit any of these same income or Cost of Sales
                      variances, and is not subjected to either of these special treatments.</p>
                    <p>Because of heavy and consistent dependence on Other Income in agricultural industries
                      1111xxx-Crops and some 112xxx-Animal Production (likely subsidy income) and in NAICS
                      813-Religious, Grantmaking, Civic, Professional, and Similar Organizations (likely non-program
                      revenue and donations), we considered the aggregation of Other Income into Business Revenue in
                      these industries, but did not make that adjustment in this release. </p>
                  </div>
                </div>
              </md-tab>

              <md-tab id="quality-control" md-label="Quality Control" md-icon="check_box" class="p-0 ss">
                <div class="md-toolbar-row fundamentals_area p-0">
                  <div class="extra_space">
                    <h1 class="md-title text-left profile-title">
                      Quality Control
                    </h1>
                    <h2 class="title-h3-formatting">Industry Financial</h2>
                    <p>
                      After our update in December 2011, customer feedback and our own internal review process noted
                      larger than usual year-to-year fluctuations in some financial reports. <br /><br />

                      In part, continuing ripples from the 2008 recession generated less consistent profit and loss
                      statements and balance sheets in many industry groups. This is the result of both relative
                      economic instability and concentrated efforts in some industry sectors to attain greater
                      efficiencies. Either tendency can disrupt the consistency that is most comfortable for those
                      reviewing aggregate financial statements.

                    </p>
                    <p>
                      However, two other factors also affected our reporting: The first involves the relatively relaxed
                      parameters we have used to filter out outliers during our analysis process (see more on Outlier
                      Values below). The second concerns widely varying line item allocation choices, especially in the
                      profit and loss statement, among companies in some industries. In the past we have been reluctant
                      to “normalize” these, but have now changed course (see more on Line Item Allocation below).
                    </p>
                    <p>
                      In response to these two factors, we completed a four-month quality control review of our Industry
                      Financial and Micro-Firm Profit and Loss reporting series. While with few exceptions previously
                      displayed data was correctly analyzed and reported, we recognized that our previous approach to
                      outlier data and line item allocations may have made the interpretation of the data more difficult
                      than it should have been. Our quality control review process addressed these and other issues,
                      with major focus on the Profit and Loss section of reports.
                    </p>
                    <p>
                      After a final review round which eliminated previously unidentified outlier data points in
                      &#x3c;5% of the Industry Financial series reports, the entire series was re-released in August
                      2012. In addition, due to a programming error in the initial release, sales data was revised in
                      some industry segments (2007-08-09 only). Reports accessed before the August release are not
                      revised, and continue to bear a June 2012 release date.
                    </p>
                    <h3>Sole Proprietor </h3>
                    <p>
                      Both the Sole Proprietor and Startup versions of the Micro-Firm Profit and Loss series have been
                      subjected to a QC review similar to the Industry Financial series described above. However,
                      because of the peculiarities of the sole proprietorship reporting format, parameters have not been
                      drawn as tightly as is the case for the IF series, and the normalization process has been
                      modified. This is largely due to complications caused by the Net Profit line in the Micro-Firm
                      series, which (like IRS sole proprietorship reporting) includes all owner compensation, whether it
                      represents strict profit or some form of labor in any of the other line categories: Cost of Sales;
                      Wages-Salary; Commissions or SG&A. Broader line item variations in the Micro-Firm reports
                      invariably result from varying levels and type of owner activity in day to day operations. For
                      example, the owner’s Net Profit line may be 20% three years in a row, but the portion of that 20%
                      that represents actual profit in one year might be total; the portion representing owner’s labor
                      which would otherwise be classified as cost of sales might be half of the 20% in a second year;
                      and the portion representing administrative work might be half of the 20% in the third. Due to the
                      nature of standard reporting formats, more specific breakdowns of the composition of the Net
                      Profit line are not possible. In addition, due to a programming error in the previous release, the
                      previous Micro-Firm series release included some incorrect dollar content, which has now been
                      revised across the board.
                    </p>
                    <h3>Outlier Values</h3>
                    <p>
                      Based in our 2011 quality control review, we have tightened our outlier parameters to improve
                      consistency of numbers in our financial statement. This process has reduced year-to-year variances
                      while maintaining the integrity of the common size statements themselves. Narrowing filters
                      naturally increases the stability of displayed values and changes numbers that may have appeared
                      in prior releases. In some cases, we have modified the composition of our sample pool. In others,
                      we revised specific measures which were unduly influenced by outlier firms
                    </p>
                    <h3>Line Item Allocation</h3>
                    <p>We have undertaken a “normalization” process regarding subjective allocations of related line
                      item data, especially in regard to the labor portion of Cost of Sales, Salary-Wages; the labor
                      portion of Sales, General & Administrative; and, to a lesser extent, Benefits-Pension. Our review
                      evaluated significant swings in the base data that reflect subjective allocation choices in
                      company statements, rather than changes in expenditure. We found that in many cases, even within a
                      given industry, choices to allocate the same expenditures could result in three or four different
                      results in different company statements, significantly affecting our efforts to develop a common
                      size P&L. The normalization process is aimed at smoothing some of these variances. For example,
                      where we saw a dramatic drop in the labor portion of COS and a corresponding increase in
                      Wages-Salary, we might have revised the allocations while maintaining overall compensation costs.
                    </p>
                    <p>
                      In small business sales classes, we also conducted a review of Officers Compensation and Net
                      Profit, since these items often represent tax decisions rather than a real difference in
                      operations. For example, a small firm that allocates 20% of revenue to officer compensation one
                      year with 5% net profit, and 5% officer compensation the following year with 15% net profit has
                      not performed differently so much as made different tax decisions. In such a case, we might have
                      revised the allocations to normalize the year-to-year result, increasing year-to-year consistency.
                      The most significant use of this process was in small service industries (such as offices of
                      physicians, other professional or technical services) where a limited number of owner-operators or
                      partners tend to capture a large share of compensation and profit.
                    </p>
                    <p>
                      The result of these changes is financial statements that appear more stable and are more easily
                      interpreted, in most cases without much if any impact on the bottom line result. This process also
                      necessarily means that some data displayed in prior years will change., Some troughs and spikes do
                      remain; this is a normal result of industry fluctuations (especially around recessionary or high
                      growth periods) and, quite often, the scale of business activity
                    </p>
                    <p>
                      The QC review process has not yet been completed for legacy data (pre-2006).
                    </p>

                  </div>

                </div>
              </md-tab>

              <md-tab id="about-glossary" md-label="Glossary" md-icon="description" class="p-0 ss">
                <div class="md-toolbar-row fundamentals_area p-0">
                  <div class="extra_space">
                    <h1 class="md-title text-left profile-title">
                      Glossary
                    </h1>
                    <h2 class="title-h3-formatting">Balance Sheet</h2>
                    <p><strong>Cash:</strong> Money on hand in checking, savings or redeemable certificate accounts.
                    </p>
                    <p><strong>Receivables:</strong> A short-term asset (to be collected within one year) in the form of
                      accounts or notes receivable, and usually representing a credit for a completed sale or loan. </p>
                    <p><strong>Inventory:</strong> The stockpile of unsold products.</p>
                    <p><strong>Current Assets:</strong> The sum of a firm's cash, accounts and notes receivable,
                      inventory, prepaid expenses and marketable securities which can be converted to cash within a
                      single operating cycle..</p>
                    <p><strong>Fixed Assets: </strong> Long-term assets such as building and machinery, net of
                      accumulated amortization-depreciation-depletion.</p>
                    <p><strong>Total Assets: </strong> The sum of current assets and fixed assets such as plant and
                      equipment</p>
                    <p><strong>Accounts Payable: </strong> Invoices due to suppliers within the current business cycle.
                    </p>
                    <p><strong>Loans/Notes Payable: </strong> Loan amounts due to suppliers within the current business
                      cycle. </p>
                    <p><strong>Current Liabilities: </strong> Measurable debt owed within one year, including accounts,
                      loans and notes payable, accrued liabilities and taxes due </p>
                    <p><strong>Long Term Liabilities:</strong> Debt which is due in more than one year, including the
                      portion of loans and mortgages that become due after the current business cycle.</p>
                    <p><strong>Total Liabilities:</strong> Current Liabilities plus Long Term Liabilities such as notes
                      and mortgages due over more than one year. </p>
                    <p><strong>Net Worth: </strong> Current assets plus fixed assets minus current and long-term
                      liabilities. </p>
                    <p><strong>Sources and Uses: </strong> The Sources and Uses of Funds table tests the accuracy of the
                      balance sheet and distinguishes the sources of funds from their use. It is the basic worksheet
                      preliminary to a formal cash flow statement examining the liquidity of a business. A multi-year
                      industry benchmark common size balance sheet, which includes overlapped but not identical sets of
                      firms in each year, is not well-suited for the presentation of a formal cash flow analysis. </p>
                    <h3>Profit & Loss</h3>
                    <p><strong>Business Revenue</strong> includes receipts from core business operations. Interest
                      Income and Other income (such as rents and royalties) are generally detailed separately below
                      Operating Income. While Income is separated from Interest Income for most classifications, Income
                      includes interest income from the private sector where it is central to financial industry
                      operations, including Finance and Insurance (NAICS 52xxxx except NAICS 5242xx Insurance Brokers
                      and Other Insurance Activities); Real Estate-Rental-Leasing (53xxxx); and Management of Companies
                      and Enterprises (55xxxxx). </p>
                    <p><strong>Cost of Sales</strong> includes materials and labor involved in the direct delivery of a
                      product or service. Other costs are included in the cost of sales to the extent that they are
                      involved in bringing goods to their location and condition ready to be sold. Non-production
                      overheads such as development costs may be attributable to the cost of goods sold. The costs of
                      services provided will consist primarily of personnel directly engaged in providing the service,
                      including supervisory personnel and attributable overhead. </p>
                    <p><strong>Gross Margin</strong> represents direct operating expenses plus net profit. In addition
                      to the labor portion of Cost of Sales, wage costs are reflected in the Officers Compensation and
                      Wages-Salary line items. In many cases, SG&A (Sales, General and Administrative) costs also
                      include some overhead, administrative and supervisory wages. </p>
                    <p><strong>Rent</strong> covers the rental cost of any business property, including land, buildings
                      and equipment. </p>
                    <p>The <strong>Taxes paid</strong> line item includes payroll other paid-in tax items, but not
                      business income taxes due for the period. Although it can be calculated in many ways and is a
                      controversial measure, the EBITDA line item (Earnings before Interest Expense, income tax due,
                      Depreciation and Amortization) adds back interest payments, depreciation, amortization and
                      depletion allowances, and excludes income taxes due to reduce the effect of accounting decisions
                      on the bottom line of the Profit and Loss Statement. Since some firms utilize EBITDA to "add back"
                      non-cash and flexible expenses which may be altered through credits and accounting procedures
                      (such as income tax), paid-in income taxes from the Taxes Paid line item are not added back in the
                      EBITDA calculation.</p>
                    <p><strong>Advertising</strong> includes advertising, promotion and publicity for the reporting
                      business, but not on behalf of others. </p>
                    <p><strong>Benefits-Pension</strong> includes, but is not limited to, employee health care and
                      retirement costs. In addition to varying proportions of overhead, administrative and supervisory
                      wages, some generally more minor expenses are aggregated under SG&A (Sales, General and
                      Administrative).</p>
                    <p>
                      <strong>Operating Expenses</strong> sums the individual expense line items above, yielding the
                      Operating Income or net of core business operations, when subtracted from the Gross Margin.
                    </p>
                    <p>
                      <strong>Pre-Tax Net Profit</strong> represents net profit before income tax due. Income Tax
                      calculates the federal corporate tax rate before credits, leaving After-Tax Profit at the bottom
                      line.
                    </p>
                    <p>
                      <strong> Discretionary Owner Earnings</strong> sums Officer Compensation, Depreciation and related
                      non-cash expenses and Net Profit after business taxesto represent a practical measure of total
                      return to owners. The D.O.E. metric is mainly used for small businesses.
                    </p>
                    <h2>Ratios</h2>
                    <h3>Cash Flow-Solvency Ratios </h3>
                    <p><strong>Accounts Payable:</strong> Business Revenue: Accounts Payable/Annual Business Revenue,
                      measuring the speed with which a company pays vendors relative to Business Revenue. Numbers higher
                      than typical industry ratios suggest that the company may be using suppliers to float operations.
                    </p>
                    <p>
                      <strong> Current Ratio: </strong>This is the same as Current Assets/Current Liabilities, measuring
                      current assets available to cover current liabilities, a test of near-term solvency. The ratio
                      indicates to what extent cash on hand and disposable assets are enough to pay off near term
                      liabilities. The Quick Ratio is applied as a more stringent test.
                    </p>
                    <p>
                      <strong> Quick Ratio: </strong>(Cash plus Accounts Receivable)/Current Liabilities, indicating
                      liquid assets available to cover current debt. Also known as the Acid Ratio. This is a harsher
                      version of the Current Ratio, which balances short-term liabilities against cash and liquid
                      instruments.
                    </p>
                    <p>
                      <strong>Days Payables:</strong> 365/(Cost of Sales: Accounts Payable ratio): Reflects the average
                      number of days for each payable before payment is made.
                    </p>
                    <p>
                      <strong>Current Liabilities:</strong> Inventory: Current Liabilities/Inventory: A high ratio,
                      relative to industry norms, suggests over-reliance on unsold goods to finance operations.
                    </p>
                    <p>
                      <strong>Net Working Capital:</strong> Business Revenue: Net Working Capital/Business Revenue.
                      Indicates if a company is maintaining a reasonable level of liquidity relative to its Business
                      Revenue volume. A high ratio indicates an overly conservative reliance on liquid assets, while low
                      ratios suggests the opposite.
                    </p>
                    <p>
                      <strong>Cost of Sales: Accounts Payable:</strong> Measures the number of times payables turn over
                      in the course of the year. High measures may indicate cash flow concerns.
                    </p>
                    <p>
                      <strong>Cost of Sales: Inventory:</strong> Reflects the number of times inventory is turned over
                      during the course of the year. High levels can mean good liquidity or Business Revenue, or
                      shortages requiring better management. Low levels may indicate poor cash flow or overstocking.
                    </p>
                    <h3>Profitability Ratios</h3>
                    <p><strong>EBITDA: Business Revenue:</strong> Earnings Before Interest, (income) Taxes due,
                      Depreciation and Amortization/Business Revenue. EBITDA: Business Revenue is a relatively
                      controversial (and often criticized) metric designed to eliminate the effect of finance and
                      accounting decisions when comparing companies and industry benchmarks. Tax credits and deferral
                      procedures and non-cash expenditures (Amortization and Depreciation) are not deducted from the
                      profit equation, as are interest expenditures.</p>
                    <p>
                      <strong>Return on Assets:</strong> Pre-Tax or After Tax Net Profit/Total Assets, a critical
                      indicator of profitability. Companies which use their assets efficiently will tend to show a ratio
                      higher than the industry norm. The ratio may appear higher for small businesses due to owner
                      compensation draws accounted as net profit.
                    </p>
                    <p>
                      <strong>Return on Net Worth:</strong> Pre-Tax or After Tax Net Profit/Net Worth. This is the
                      'final measure' of profitability to evaluate overall return. This ratio measures return relative
                      to investment, how well a company leverages the investment in it. May appear higher for small
                      businesses due to owner compensation draws accounted as net profit.
                    </p>
                    <p>
                      <strong>Return on Business Revenue:</strong> Pre-Tax or After Tax Net Profit Net Profit/Annual
                      Business Revenue, indicating the level of profit from each dollar of Business Revenue. This ratio
                      can be used as a predictor of the company's ability to withstand changes in prices or market
                      conditions. May appear higher for small businesses due to owner compensation draws accounted as
                      net profit.
                    </p>
                    <p>
                      <strong>Discretionary Owner Earnings:</strong> Sums Officer Compensation, Depreciation and related
                      non cash expenses and Net Profit after business taxes to represent a practical measure of total
                      return to owners. The D.O.E. metric is mainly used for small businesses.
                    </p>
                    <p>
                      <strong>Profit/Employee:</strong>Pre-Tax Net Profit/Full-time Employees.
                    </p>
                    <p>
                      <strong>Owner Earnings/Employee:</strong>Discretionary Owner Earnings (Officers'
                      Compensation+Depreciation+After Tax Net Profit)/Full-time Employees.
                    </p>
                    <h3>Efficiency Ratios</h3>
                    <p>
                      <strong>Assets: Business Revenue:</strong> Total Assets/Business Revenue, indicating whether a
                      company is handling too high a volume of Business Revenue in relation to investment. Very low
                      percentages relative to industry norms might indicate overly conservative sales efforts or poor
                      sales management.
                    </p>
                    <p>
                      <strong>Days Inventory:</strong> 365/(Cost of Sales: Inventory): The average number of days of
                      items in inventory.
                    </p>
                    <p>
                      <strong>Days Receivables:</strong> 365/(Business Revenue/Receivables): Reflects the number of days
                      that receivables are outstanding. Target average or lower.
                    </p>
                    <p>
                      <strong>Current Asset Turnover:</strong> Business Revenue/Current Assets. A general indicator of
                      the efficiency of asset use. Target at or slightly below industry level.
                    </p>
                    <p>
                      <strong>Fixed Asset Turnover: </strong>Business Revenue/Fixed Assets. An indicator of the
                      efficiency of investment in fixed asset such as plant and equipment. Target at or slightly below
                      industry level.
                    </p>
                    <p>
                      <strong>Gross Margin: Business Revenue: </strong>Pre-tax Gross Profit/Annual Business Revenue.
                      This is the profit ratio before product and Business Revenue costs, as well as taxes. This ratio
                      can indicate the "play" in other expenses which could be adjusted to increase the Net Profit
                      margin.
                    </p>
                    <p>
                      <strong>Sales per Employee: </strong> Business Revenue/FTE Employees: A basic efficiency measure
                      developed outside the formal financial statement, often reflecting relative value-added. Higher is
                      usually better.
                    </p>
                    <p>
                      <strong>Inventory Turnover: </strong> Business Revenue/Inventory. This ratio gives a picture of
                      how quickly inventory turns over. Ratios below the industry norm suggest high levels of inventory.
                      High ratios could indicate product levels insufficient to satisfy demand in a timely manner.
                      Target: at or slightly above industry level.
                    </p>
                    <p>
                      <strong>Receivables Turnover: </strong> Business Revenue/Receivables. An indicator of how
                      efficiently invoiced sales are collected. Target at or slightly above industry level.
                    </p>
                    <p>
                      <strong>Total Asset Turnover: </strong>Business Revenue/Total Assets. Target: at or slightly below
                      industry level.
                    </p>
                    <p>
                      <strong>Working Capital Turnover: </strong> Business Revenue divided by Net Working Capital
                      (current assets minus current liabilities). Ratios higher than industry norms may indicate a
                      strain on available liquid assets, while low ratios may suggest too much liquidity. Target: at or
                      above industry level.
                    </p>
                    <p>
                      <strong>Days Working Capital: </strong> : 365/ (Working Capital Turnover): Expresses the coverage
                      in number of days of available working capital.
                    </p>
                    <p>
                      <strong>Cash Turnover: </strong> : Business Revenue/Cash. Indicates efficiency in the use of cash
                      to develop Business Revenue. A more stringent ratio than Working Capital Turnover (below). Target
                      at or slightly below industry level.
                    </p>
                    <p>
                      <strong>Efficiency Index:</strong> Sales per Employee/Average Annual Employee Wage.
                    </p>
                    <h3>Debt-Risk Ratios </h3>
                    <p><strong>Interest Coverage:</strong> EBITDA/Interest Expense: Earnings before Interest, (income)
                      Taxes due, Depreciation and Amortization divided by Interest expense. Assesses financial stability
                      by examining whether a company is at least profitable enough to pay interest expense. A ratio
                      >1.00 indicates it is. See cautions in the listing for EBITDA.</p>
                    <p><strong>Current Liabilities: Net Worth:</strong> Total Current Liabilities/Net Worth, a measure
                      of short-term debt coverage (>1 year). This ratio reflects a level of security for creditors. The
                      larger the ratio relative to industry norms, the less security there is for creditors. </p>
                    <p><strong>Long-Term Liabilities: Net Worth:</strong> Long-Term Liabilities/Net Worth, a measure of
                      coverage of long-term debt (>1 year).</p>
                    <p><strong>Loans/Notes Payable:</strong> Net Worth: The Loans/Notes Payable portion of current
                      liabilities divided by Net Worth, a measure of debt coverage. </p>
                    <p>
                      <strong>Modified Z-Score:</strong> A modified form of the Altman Z-Score which evaluates default
                      risk. The modified Z-Score substitutes Discretionary Owner Earnings for Net Profit and Net Worth
                      for Retained Earnings to better capture small business operations. In all cases higher (at or
                      above the industry level) is desired. Modified Z-Score calculations for this industry are:
                    </p>
                    <p><strong>For manufacturing industries:</strong> ([Working Capital/Total Assets]*0.717) +
                      ([Discretionary Owner Earnings/Total Assets]*0.847) + ([Operating Income/Total Assets]*3.107) +
                      ([Net Worth/Total Liabilities]*0.420) + ([Sales/Total Assets]*.998) </p>
                    <p>
                      <strong> For all non-manufacturing industries:</strong> ([Operating Income/Total Assets]*6.72) +
                      ([Net Worth/Total Liabilities]*1.05) + ([Working Capital/Total Assets]*6.5) + ([Discretionary
                      Owner Earnings/Total Assets]*3.26)
                    </p>
                    <p>
                      <strong>Total Liabilities:</strong> Net Worth: Total Liabilities/Net Worth, a measure of coverage
                      of total debt (short and long-term). Creditors are concerned to the extent that total liability
                      levels exceed Net Worth.
                    </p>
                    <p>
                      <strong>Fixed Assets:</strong> Net Worth: Fixed Assets/Net Worth. High ratios relative to the
                      industry can indicate low working capital or high levels of debt.
                    </p>
                  </div>
                </div>
              </md-tab>

              <md-tab id="about-data" md-label="Data" md-icon="storage" class="p-0 ss">
                <div class="md-toolbar-row fundamentals_area p-0">
                  <div class="extra_space">
                    <h1 class="md-title text-left profile-title">
                      Data
                    </h1>
                    <p>
                      Bizminer produces the most granular industry statistical reports in the market.
                      Bizminer data is widely accepted for industry analytical work, benchmarking, valuations, forensics
                      and litigation. Bizminer content is accepted in US Tax Court (Bauer vs. IRS: T.C. Memo. 2012-156)
                      and is utilized by state, provincial and national taxing agencies in the US and
                      Canada.<br /><br />

                      Raw data analyzed for Bizminer reports is sourced from an array of the nation's government and
                      private statistical sources. None of these raw data sources creates the final measures reflected
                      in Bizminer industry profiles. In total, Bizminer accesses over a billion sourced data points from
                      15 million business operations for each of its twice annual updates covering a 3-5 year time
                      series. Historical data and Bizminer algorithms are used to inform and test projections for
                      non-reporting firms. Data elements are sourced specifically from:

                    </p>
                    <p>
                      While 100% firm coverage is desirable for analysis purposes, the greatest value of Bizminer
                      reports rests in discerning patterns of activity, which are reflected in the large samples used to
                      develop our reports. The overall current coverage of the databases surpasses 13 million active
                      business operations at any point in time. As is the case with any databases this large, some
                      errors are inevitable. Some firms are missed and specific information on others is lacking from
                      the database. Not all information received is uniform or complete, resulting in the need to
                      develop projection algorithms for specific industry segments and metrics in some report series. No
                      representation is made as to the accuracy of the databases utilized or the results of subsequent
                      analyses.
                    </p>
                    <ul class="columnize">
                      <li>IRS SOI Corporation Tax Book</li>
                      <li>IRS Statistics of Income</li>
                      <li>US Economic Census</li>
                      <li>US Census Quarterly Financial Reports</li>
                      <li>US Census County Business Patterns</li>
                      <li>
                        Bureau of Labor Statistics Monthly Employment Reports
                      </li>
                      <li>
                        Bureau of Labor Statistics Monthly Unemployment
                        Reports
                      </li>
                      <li>Bureau of Labor Statistics Annual Wage Survey</li>
                      <li>
                        Bureau of Labor Statistics Industry Productivity
                        Reports
                      </li>
                      <li>Bureau of Labor Statistics Price Indices</li>
                      <li>National Agricultural Statistical Service</li>
                      <li>US Census Quarterly Financial Reports</li>
                      <li>US Census Retail Trade Report</li>
                      <li>Data Axle</li>
                      <li>Business Valuation Resources (BVR)</li>
                      <li>Credit Reporting Agencies</li>
                      <li>Business Directories</li>
                      <li>American Community Survey</li>
                    </ul>
                    <h3>Disclosure </h3>
                    <p>As is the case with any databases this large, some errors are inevitable. Some firms are missed
                      and specific information on others is lacking from the database. Not all information received is
                      uniform or complete, resulting in the need to develop projection algorithms for specific industry
                      segments and metrics in some report series. No representation is made as to the accuracy of the
                      databases utilized or the results of subsequent analyses. Neither the Brandow Company nor its
                      resellers has undertaken independent primary research to confirm the accuracy of the data utilized
                      in the Profile analyses. Neither the Brandow Company nor its resellers are responsible for
                      conclusions drawn or decisions made based upon this data or analysis. In no event will the Brandow
                      Company or its resellers be liable for any damages, direct, indirect, incidental or consequential
                      resulting from the use of the information contained in BizMiner reports. </p>
                    <p>
                      This product has been supplied by IBISWorld Inc. (‘IBISWorld’) solely for use by its authorized
                      licenses strictly in accordance with their license agreements with IBISWorld. IBISWorld makes no
                      representation to any other person with regard to the completeness or accuracy of the data or
                      information contained herein, and it accepts no responsibility and disclaims all liability (save
                      for liability which cannot be lawfully disclaimed) for loss or damage whatsoever suffered or
                      incurred by any other person resulting from the use of, or reliance upon, the data or information
                      contained herein. Copyright in this publication is owned by IBISWorld Inc. The publication is sold
                      on the basis that the purchaser agrees not to copy the material contained within it for other than
                      the purchasers own purposes. In the event that the purchaser uses or quotes from the material in
                      this publication – in papers, reports, or opinions prepared for any other person – it is agreed
                      that it will be sourced to: IBISWorld Inc.
                    </p>
                  </div>

                </div>
              </md-tab>


            </md-tabs>
          </template>
        </nav-tabs-card>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard } from "@/components";
import { mapActions, mapState } from 'vuex';
import axios from "axios";

export default {
  components: {
    // Collapse,
    NavTabsCard,
    //PulseLoader
  },
  data() {
    return {
      industry: null,
      bznaics: null,
      loading: false,
      filtered_company_list: [],
    };
  },
  async mounted() {
   
   let me = this;
    let filteredCompany = [];
    if (this.companyList) {
      this.fillFilteredCompany();
    }
    filteredCompany.map(item => {
      if (item.businessName.includes(',')) {
        item.businessName = item.businessName.replace(/,/g, '');
        return item
      }
      if (item.earningsMedian.includes(',')) {
        item.earningsMedian = item.earningsMedian.replace(/,/g, '.');
        return item
      }
      return item
    })
    filteredCompany.forEach((element, index) => {
      let c = Object.values(element);
      let r = [];
      c.forEach((el, i) => {
        r.push(el);
      })
      this.filtered_company_list.push(r);
    })
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
    }),
    /*id() {
      return this.$route.params.id;
    },
    industry_code() {
      return this.bznaics ? this.bznaics : null;
    },
    industry_name() {
      return this.industry ? this.industry : null;
    },*/
    companyList() {
      return this.$store.getters.companyList;
    },
    getCsvData() {
      let csvData = [
        [
          'Locnum', 'Estimated Sales', 'Business Name', 'Industry Code', 'Industry Name', 'Location Address', 'Suite', 'City', 'Zip', 'Zip+4',
          'State Abbreviation', 'Mailing Address', 'Mailing Address City', 'Mailing Address State', 'Mailing Address Zip', 'Primary Phone Number',
          'Contact First Name', 'Contact Last Name', 'Contact Title', 'Location Employment', 'URL', 'Earnings Approach Median Value', 'Credit.net Score'
        ],
      ]
      this.filtered_company_list.forEach((e, i) => {
        csvData.push(e);
      });
      return csvData;
    },
  },
  methods: {
    ...mapActions({
      registerProductExport: 'tracking/registerProductExport',
    }),
    fillFilteredCompany: function(){
       this.companyList.forEach((el, i) => {
        let a = {};
        a.locnum = el.locnum.toExponential(4);
        a.sales = el.sales
        a.businessName = el.businessName
        a.industryCode = me.industry_code
        a.industryName = me.industry_name
        a.locationAddress = el.locAddress
        a.suite = el.suite
        a.city = el.city
        a.zip = el.zip
        a.zip4 = el.zip4
        a.stateAbbrevation = el.state
        a.mailAddress = el.mailAddress
        a.mailAddressCity = el.mailAddressCity
        a.mailAddressState = el.mailAddressState
        a.mailAddressZip = el.mailAddressZip
        a.phonePrimary = el.phonePrimary
        a.contactFirst = el.contactFirst
        a.contactLast = el.contactLast
        a.contactTitle = el.contactTitle
        a.locationEmp = el.locationEmp
        a.url = el.url
        a.earningsMedian = el.earningsMedian
        a.creditNetScore = el.creditNetScore
        filteredCompany.push(a);
      })
    },
   
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += "\n";
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Company List.csv';
      anchor.click();
      this.registerProductExport({
          userId: this.auth_user?.user?.userID,
          productId: this.$route.params.id,
          exportType: 'CSV'
      })
    },
  },

  watch:{
   /* companyList(newVal,oldVal){
      if(newVal)
        this.fillFilteredCompany()
    }*/
  }
};
</script>

<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.company-list-title {
  margin: 0 !important;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.if-profile-body {
  .companis-list-tabl {
    .favorite-list-item {
      .list-item-head {
        align-items: center;
      }
    }
  }
}

/*.if-profile .if_card .md-card-content p {
  font-size: 14px;
  line-height: 19px !important;
  font-weight: 400 !important;
  color: #000000;
}*/

</style>
